export enum AuthPageState {
  Initializing,
  Pending,
  Invalid,
  Submitted,
  Error,
  Success,
}
